
import { Quest, QuestCategory } from '../../../types';

export const STANDARD_SKILL_BUILDER_QUESTS: Quest[] = [
  { 
    id: 19, 
    category: QuestCategory.SkillBuilder, 
    title: 'Dishwasher Pro', 
    description: 'Learn the correct way to load or unload the dishwasher.',
    details: "This is a key household skill. Ask an adult to show you the proper way to load or unload the dishwasher. Learn the system: where things go, how to be efficient, and how to get everything sparkling clean.",
    repeatDescription: "Time to show your skills. Load or unload the dishwasher like a pro.",
    repeatDetails: "You know the system! Your mission is to either load the dirty dishes or unload the clean ones. A well-loaded dishwasher is a work of art. Make sure nothing blocks the spinning arms!"
  },
  { 
    id: 20, 
    category: QuestCategory.SkillBuilder, 
    title: 'Laundry Legend', 
    description: 'Learn the secret to good laundry: how to sort it correctly before washing.',
    details: "Sorting clothes is the first step to becoming a Laundry Legend. Ask an adult to show you how to sort a basket into three piles: Whites, Darks, and Colours. This stops colours from running and keeps clothes looking great.",
    repeatDescription: "A pile of laundry appears! Sort it into the correct piles.",
    repeatDetails: "You've been trained in the laundry arts. Find a basket of dirty clothes and sort it into whites, darks, and colours. This super helpful job gets the washing machine ready for its next mission."
  },
  { 
    id: 21, 
    category: QuestCategory.SkillBuilder, 
    title: 'Waste & Recycling Warden', 
    description: 'Learn the bin schedule and how to manage the kitchen bins.',
    details: "Every hero needs to manage their waste. Ask an adult to explain the bin schedule: what day is collection? Which bins go out? Also, learn the important skill of taking out the full kitchen bin bag and replacing it with a new one.",
    repeatDescription: "It's bin day! Take the correct bins out for collection.",
    repeatDetails: "Today, you are the Waste & Recycling Warden. Your mission is to take the correct bins out to the street. And remember, if the kitchen bin is full, a good warden knows what to do!"
  },
  { 
    id: 25, 
    category: QuestCategory.SkillBuilder, 
    title: 'The 15-Minute Tidy', 
    description: 'A clean space is a happy space. Spend 15 minutes tidying your bedroom.',
    details: "You don't have to make your room perfect, just better. Set a timer for 15 minutes and go! Focus on three things: 1. Dirty clothes in the basket. 2. Rubbish in the bin. 3. Toys and books back where they belong. You'll be amazed what you can do.",
    repeatDescription: "Accept the 15-minute challenge and make your bedroom tidy.",
    repeatDetails: "You know the drill! Put on some music, set a timer for 15 minutes, and blitz your room. Focus on clothes, rubbish, and putting things away. Go, go, go!"
  },
  { 
    id: 84, 
    category: QuestCategory.SkillBuilder, 
    title: 'Literary Explorer', 
    description: 'Adventures aren\'t just outside. Read a chapter of a book for 20 minutes.',
    details: "Find a comfy spot, grab a book, and get lost in a new world for 20 minutes. Set a timer so you don't have to watch the clock. Reading is a workout for your brain and your imagination.",
    repeatDescription: "Time to read! Explore a new world for 20 minutes without leaving the house.",
    repeatDetails: "Continue your current adventure or start a new one. Find a quiet spot and read for 20 minutes. What's happening in your story? Is the hero in trouble or making a new discovery? Enjoy the journey."
  },
  { 
    id: 86, 
    category: QuestCategory.SkillBuilder, 
    title: 'Master of the Bed', 
    description: 'Learn the simple, quick skill of making your bed neatly each morning.',
    details: "Starting the day by making your bed is a powerful habit. Ask an adult to show you the quick way to make your bed look neat. Straighten the sheet, pull up the duvet, and arrange the pillows. It makes your whole room look better in under a minute.",
    repeatDescription: 'Be the Master of the Bed and make it neatly without being asked.',
    repeatDetails: "Your first mission of the day, should you choose to accept it: make your bed. A tidy bed makes your whole room feel more organized and ready for action. You can do it in less than a minute. Go!"
  },
  { 
    id: 89, 
    category: QuestCategory.SkillBuilder, 
    title: 'Keyboard Ninja', 
    description: 'Spend 15 minutes practicing your typing skills to become faster and more accurate.',
    details: "Typing without looking at the keys is a real-life superpower. Find a free typing tutor online (like Typing.com) and spend 15 minutes practicing. Focus on using the right fingers for each key—that's the secret to ninja speed!",
    repeatDescription: 'Train your fingers! Practice your typing skills for 15 minutes.',
    repeatDetails: "Time to power up your WPM (words per minute). Go to your favourite typing website and train for 15 minutes. Can you beat your high score? Can you achieve 100% accuracy? The path to becoming a Keyboard Ninja requires practice.",
    youtubeId: 'I3322Vd2A2Q'
  },
  { 
    id: 700, 
    category: QuestCategory.SkillBuilder, 
    title: 'Digital Organizer', 
    description: 'Learn the powerful skill of creating and organizing files in Google Drive.',
    details: "Time to learn a digital superpower. Ask an adult to help you log into Google Drive. Learn to: 1. Create a new folder. 2. Create a new Google Doc inside it. 3. Create a new Google Slides presentation. This is where your digital projects can live!",
    repeatDescription: 'Practice your digital skills. Create a new document or presentation in Google Drive.',
    repeatDetails: "You are a Digital Organizer. Today, choose a task: write a short story in Google Docs, or create a presentation about your favourite game in Google Slides. Remember to give your file a clear name and keep your digital world tidy."
  },
  {
    id: 701,
    category: QuestCategory.SkillBuilder,
    title: 'Pantry Manager',
    description: 'Learn a key household skill: keeping track of what\'s needed for the food shopping.',
    details: "A great Pantry Manager knows what the household needs. Ask an adult to show you the shopping list. Your mission: check the fridge and cupboards, find 3 items that are running low, and add them to the list. You are helping the whole team!",
    repeatDescription: 'Do a patrol of the kitchen. Find 3 items running low and add them to the shopping list.',
    repeatDetails: "Time for a kitchen patrol! Check the fridge, fruit bowl, and cupboards. Find at least three items that are nearly gone and add them to the family shopping list. Your contribution helps the whole household run smoothly."
  },
  {
    id: 1101,
    category: QuestCategory.SkillBuilder,
    title: 'The Sock Matcher',
    description: 'Learn the art of pairing socks and putting them away.',
    details: "Tame the laundry beast! Find the pile of clean socks, match them into pairs, and roll or fold them neatly. Put them away in the correct drawer. It's a small task that makes getting dressed much faster.",
    repeatDescription: 'A pile of lonely socks needs your help! Match them up.',
    repeatDetails: 'Your mission is to find the sock pile and create perfect pairs. No sock gets left behind! This is a great, quick job to help with the laundry.'
  },
  {
    id: 1102,
    category: QuestCategory.SkillBuilder,
    title: 'Shoe Tidy Shinobi',
    description: 'Learn to keep the entrance of the house clear by tidying all the shoes.',
    details: "A cluttered hallway is a mission for a shinobi. Learn where the shoes are supposed to live. Your first mission is to neatly pair up and put away all the shoes by the door. A clear floor is a sign of a true master.",
    repeatDescription: 'The shoes are in chaos! Bring order to the entranceway.',
    repeatDetails: 'A Shoe Tidy Shinobi strikes with speed and silence. Neatly arrange all the shoes in their proper storage place. A tidy entrance makes the whole house feel more peaceful.'
  },
  {
    id: 1103,
    category: QuestCategory.SkillBuilder,
    title: 'The Waterer',
    description: 'Learn which house plants need watering and how often.',
    details: "Plants get thirsty too. Ask an adult to show you which plants need watering. Learn how to check if the soil is dry and how much water to give them. It's a big responsibility to keep living things healthy.",
    repeatDescription: 'Check the plants. Do any of them need a drink?',
    repeatDetails: "You are the guardian of the green things. Gently check the soil of the house plants. If any are dry, give them a drink. Your care helps them thrive."
  },
  {
    id: 1104,
    category: QuestCategory.SkillBuilder,
    title: 'Table Setting Expert',
    description: 'Learn the correct way to set the table for a family meal.',
    details: "Setting the table is more than just putting out plates. Learn where the fork, knife, spoon, and glass go for a proper place setting. It makes a normal meal feel a bit more special.",
    repeatDescription: 'Time for dinner! Set the table for the family.',
    repeatDetails: "Show off your skills as a Table Setting Expert. Your mission is to set a place for everyone at the dinner table. A well-set table is the first step to a great family meal."
  },
  {
    id: 1106,
    category: QuestCategory.SkillBuilder,
    title: 'The Email Apprentice',
    description: 'With an adult, learn how to compose and send a simple email.',
    details: "Email is a key life skill. Ask an adult to help you write and send a simple email. It could be to a grandparent or a family friend. Learn about the 'To' field, the 'Subject' line, and how to write a polite message.",
    repeatDescription: 'Practice your digital communication skills by writing an email.',
    repeatDetails: 'With permission, write a short email to a family member. It could be to say hello, share a joke, or tell them about your day. Remember to write a clear subject line!'
  },
  {
    id: 1107,
    category: QuestCategory.SkillBuilder,
    title: 'The Budget Planner',
    description: 'If you had £10 to spend on snacks for a movie night, what would you buy?',
    details: "Learn the basics of budgeting. Imagine you have £10. Look at a supermarket website and plan a shopping list of snacks and drinks for a movie night. Try to get as close to £10 as possible without going over. Write down your list and the total cost.",
    repeatDescription: 'Plan a new budget. This time for a £15 perfect picnic.',
    repeatDetails: 'You have a budget of £15. Plan the food and drink for a perfect picnic for two people. Write down your shopping list and add up the costs to make sure you stay within budget.'
  },
  {
    id: 1108,
    category: QuestCategory.SkillBuilder,
    title: 'The Thank You Note Writer',
    description: 'Learn the importance of gratitude by writing a thank you note.',
    details: "After receiving a gift or a kind gesture, it's important to show you're thankful. Write a short note or card to someone to thank them. It doesn't have to be long, just sincere. It's a small act that means a lot.",
    repeatDescription: 'Think of something you are grateful for and write a thank you note.',
    repeatDetails: "Practicing gratitude makes us happier. Write a short thank you note to a friend or family member, thanking them for something specific. It will make their day, and yours."
  },
  {
    id: 1109,
    category: QuestCategory.SkillBuilder,
    title: 'The Towel Folder',
    description: 'Learn the proper technique for folding bath towels so they stack neatly.',
    details: "There's a secret to neatly folded towels! Ask an adult to show you the 'hotel fold' technique. It helps them stack perfectly in the cupboard and makes the bathroom look tidier.",
    repeatDescription: 'A pile of clean towels needs your folding expertise.',
    repeatDetails: "Time to tame the towels. Practice your folding technique on a pile of clean towels. A neat stack of towels is a sign of a true skill-builder."
  },
  {
    id: 1110,
    category: QuestCategory.SkillBuilder,
    title: 'The Pet Feeder',
    description: 'Learn the responsibility of feeding a pet correctly.',
    details: "If you have a pet, they rely on you. Ask an adult to show you exactly how much food the pet gets and at what time. Learn the whole routine, including giving them fresh water.",
    repeatDescription: 'It\'s dinner time for a furry friend. Feed the pet.',
    repeatDetails: "Time to take charge of feeding the pet. Remember the correct amount of food and to provide fresh water. It's a very important job!"
  },
  {
    id: 1111,
    category: QuestCategory.SkillBuilder,
    title: 'The Mirror Cleaner',
    description: 'Learn how to clean a mirror without leaving streaks.',
    details: "A clean mirror makes a whole room feel brighter. Ask an adult for the right cleaner and cloth. Learn the technique of wiping in one direction to get a perfect, streak-free shine.",
    repeatDescription: 'The bathroom mirror is looking a bit spotty. Make it shine!',
    repeatDetails: 'Unleash your cleaning power on a dirty mirror. Use the correct technique to leave it sparkling. You can do the same for a window!'
  },
  {
    id: 1112,
    category: QuestCategory.SkillBuilder,
    title: 'The Public Speaker',
    description: 'Prepare and practice a one-minute talk on your favourite hobby.',
    details: "Sharing your passions is a great skill. In your notebook, jot down a few key points about a hobby you love. Then, practice talking about it for one minute. Try to be engaging and enthusiastic.",
    repeatDescription: 'Prepare a new one-minute talk about a book or movie you love.',
    repeatDetails: "Time to be an orator. Prepare a short, one-minute speech about a different topic. The more you practice speaking, the more confident you'll become."
  },
  {
    id: 1113,
    category: QuestCategory.SkillBuilder,
    title: 'The Plan Follower',
    description: 'Follow a simple recipe or the instructions to build a small Lego set.',
    details: "The ability to follow instructions is a superpower. Choose a task with steps—like a recipe or Lego manual. Your mission is to follow each step carefully and in order, without skipping ahead. The result will be perfect.",
    repeatDescription: 'Time to test your focus. Follow a new set of instructions.',
    repeatDetails: "Find a new challenge that requires following steps. It could be a new recipe, a different Lego model, or even an origami tutorial. Pay attention to the details."
  },
  {
    id: 1114,
    category: QuestCategory.SkillBuilder,
    title: 'The Room Inspector',
    description: 'Inspect your room for 5 things that are out of place and put them away.',
    details: "See your room with new eyes. Stand in the doorway and become an inspector. Your mission is to identify five items that are not in their proper home. Once identified, your mission is to relocate them.",
    repeatDescription: 'Time for another inspection. Find 5 misplaced items and put them away.',
    repeatDetails: 'A good inspector is always on duty. Scan your room and find five things that need to be put back where they belong. A tidy space is a tidy mind.'
  },
  {
    id: 1115,
    category: QuestCategory.SkillBuilder,
    title: 'The Calendar Keeper',
    description: 'Learn to check the family calendar for any important events this week.',
    details: "Knowing what's coming up is a great life skill. Ask an adult to show you the family calendar (digital or physical). Your mission is to find out and report back on one important event happening this week.",
    repeatDescription: 'Check the calendar. What is one thing happening tomorrow?',
    repeatDetails: 'Stay one step ahead. Check the calendar and find out what\'s planned for tomorrow. Being prepared is a sign of a true skill-builder.'
  },
  {
    id: 1116,
    category: QuestCategory.SkillBuilder,
    title: 'The Handshake',
    description: 'Learn how to give a good, firm handshake.',
    details: "A good handshake shows confidence. Practice with an adult. Learn to make eye contact, use a firm (but not crushing) grip, and give a couple of shakes. It’s a skill you’ll use your whole life.",
    repeatDescription: 'Practice your firm, confident handshake with a family member.',
    repeatDetails: "A handshake is a first impression. Find a family member and practice your technique. Remember: eye contact, firm grip, confident smile."
  },
  {
    id: 1118,
    category: QuestCategory.SkillBuilder,
    title: 'The Digital Detoxer',
    description: 'Practice self-control by having one hour of no-screen time.',
    details: "Your brain needs time to rest and reset. Challenge yourself to have one full hour with no screens at all—no TV, no tablet, no computer. You can read, draw, go outside, or build something. You'll be amazed at what you can do.",
    repeatDescription: 'Challenge yourself. Can you go for 90 minutes without screens?',
    repeatDetails: "Level up your self-control. This time, the challenge is 90 minutes of screen-free activity. What new adventure will you have with your extra time?"
  },
  {
    id: 1119,
    category: QuestCategory.SkillBuilder,
    title: 'The Mindful Minute',
    description: 'Learn to focus your mind by practicing one minute of mindful breathing.',
    details: "Calm your mind in just 60 seconds. Sit comfortably, close your eyes, and focus only on your breath. Breathe in slowly through your nose, and out slowly through your mouth. If your mind wanders, just gently bring it back to your breath.",
    repeatDescription: 'Practice your focus with another mindful minute.',
    repeatDetails: "Find a quiet spot and focus on your breathing for one minute. This is a great skill to use when you're feeling stressed or need to concentrate."
  },
  {
    id: 1120,
    category: QuestCategory.SkillBuilder,
    title: 'The Duvet Cover Wrestler',
    description: 'Learn the technique for putting a clean cover on a duvet.',
    details: "It's a tricky challenge, but you can be its master. Ask an adult to show you the 'burrito' or 'inside-out' method for easily putting on a duvet cover. It's a household skill that feels like a magic trick.",
    repeatDescription: 'A naked duvet needs your help. Put its cover on.',
    repeatDetails: 'Time to wrestle the duvet. Use the technique you learned to get the cover on smoothly. You are the champion of bedding!'
  },
  {
    id: 1121,
    category: QuestCategory.SkillBuilder,
    title: 'The Compliment Giver',
    description: 'Learn the power of kind words by giving a sincere compliment.',
    details: "You can make someone's day with a few words. Your mission is to give a genuine compliment to someone in your family. It has to be specific and true, like 'You are really good at drawing' or 'I really liked how you helped me earlier'.",
    repeatDescription: 'Brighten someone\'s day. Give a sincere compliment.',
    repeatDetails: 'Kindness is a skill. Find someone and give them a real, thoughtful compliment. Notice how it makes you both feel good.'
  },
  {
    id: 1122,
    category: QuestCategory.SkillBuilder,
    title: 'The Dusting Duelist',
    description: 'Learn how to properly dust a room.',
    details: "Dust is the enemy! Ask for a duster and learn the best way to trap dust, not just move it around. Learn the golden rule: always dust from top to bottom.",
    repeatDescription: 'Challenge the dust. Pick a room and dust its surfaces.',
    repeatDetails: 'Time for a duel with dust. Choose a room and, remembering to work from top to bottom, make its surfaces clean and shiny.'
  },
  {
    id: 1123,
    category: QuestCategory.SkillBuilder,
    title: 'The Daily Planner',
    description: 'Practice planning by writing down three things you want to achieve tomorrow.',
    details: "A plan helps you succeed. Before bed, get your notebook and write down three simple, achievable goals for the next day. It could be 'Finish my homework', 'Practice my typing', and 'Tidy my desk'.",
    repeatDescription: 'Plan for success. Write down your top three goals for tomorrow.',
    repeatDetails: "What does a successful tomorrow look like? Write down three things you want to accomplish. This simple habit is a key to productivity."
  },
  {
    id: 1124,
    category: QuestCategory.SkillBuilder,
    title: 'The Politeness Pro',
    description: 'Focus on using "please" and "thank you" all day.',
    details: "Good manners are a superpower that makes everyone feel respected. Your mission for today is to make a special effort to use 'please' when you ask for something and 'thank you' when you receive something.",
    repeatDescription: 'Activate Politeness Pro mode for the day.',
    repeatDetails: "Continue your training in the art of courtesy. Remember to use your magic words ('please' and 'thank you') throughout the day."
  },
  {
    id: 1125,
    category: QuestCategory.SkillBuilder,
    title: 'The Silverware Sorter',
    description: 'Learn where all the cutlery lives by emptying the dishwasher cutlery basket.',
    details: "Bring order to the cutlery drawer. Your mission is to take the clean cutlery from the dishwasher and put it all away in the correct sections. It's like a sorting puzzle!",
    repeatDescription: 'The clean cutlery needs a home. Sort it and put it away.',
    repeatDetails: 'Time to sort the spoons from the forks. Empty the cutlery basket and put everything in its rightful place. A tidy drawer is a happy drawer.'
  },
  {
    id: 1126,
    category: QuestCategory.SkillBuilder,
    title: 'The Backpack Organizer',
    description: 'Learn to keep your school bag organized.',
    details: "A tidy bag helps you be ready for school. Empty out your backpack completely. Throw away any rubbish, put letters for parents aside, and organize your books and pencil case neatly. Do this once a week to stay on top of things.",
    repeatDescription: 'Time for a backpack check. Tidy and organize your school bag.',
    repeatDetails: "A true skill-builder is always prepared. Take 10 minutes to empty and reorganize your school bag so you're ready for your next day of learning."
  },
  {
    id: 1130,
    category: QuestCategory.SkillBuilder,
    title: 'The Bedtime Preparer',
    description: 'Learn to get your clothes ready for the next day before you go to bed.',
    details: "Make your mornings easier. Before you go to sleep, choose and lay out your entire outfit for the next day, from your socks to your shirt. A little planning at night makes for a stress-free morning.",
    repeatDescription: 'Prepare for a smooth morning. Lay out your clothes for tomorrow.',
    repeatDetails: "Be your future self's best friend. Take a few minutes to pick out your clothes for tomorrow. Your morning self will thank you."
  },
  {
    id: 1131,
    category: QuestCategory.SkillBuilder,
    title: 'The Floor Sweeper',
    description: 'Learn the correct way to sweep a hard floor.',
    details: "Learn the art of sweeping. Get a brush and dustpan. The trick is to sweep everything into one small pile before trying to get it in the pan. Don't chase the dirt around!",
    repeatDescription: 'The kitchen floor needs a sweep. Show it your skills.',
    repeatDetails: 'Grab a brush and sweep the floor. Remember to make one neat pile. A clean floor is a satisfying achievement.'
  },
  {
    id: 1132,
    category: QuestCategory.SkillBuilder,
    title: 'The Mental Mathematician',
    description: 'Practice your mental arithmetic for 10 minutes.',
    details: "Give your brain a workout. Ask an adult to quiz you on your times tables, or use an online game to practice addition, subtraction, multiplication, and division. A strong mind is your greatest tool.",
    repeatDescription: 'Time for a brain workout. Practice your mental maths.',
    repeatDetails: 'Challenge your brain. Spend 10 minutes on a mental maths app or getting quizzed. Can you get faster and more accurate?'
  },
  {
    id: 1133,
    category: QuestCategory.SkillBuilder,
    title: 'The Change Counter',
    description: 'Learn to count change and handle money.',
    details: "Handling money is an important skill. Get a pile of coins and practice counting them up. Ask an adult to play 'shop' with you, where you have to buy something and work out the correct change.",
    repeatDescription: 'Practice makes perfect. Count up a pile of coins.',
    repeatDetails: 'Time for some financial fitness. Get a handful of coins and practice counting them into pounds and pence. It\'s a skill you\'ll use every day.'
  },
  {
    id: 1135,
    category: QuestCategory.SkillBuilder,
    title: 'The Jacket Hanger',
    description: 'Learn the habit of hanging up your coat or jacket when you come inside.',
    details: "A simple habit that keeps the house tidy. The moment you come in from outside, your mission is to take off your jacket and hang it up properly on a hook or a hanger. No floor piles allowed!",
    repeatDescription: 'You\'ve just come inside. What do you do with your coat?',
    repeatDetails: 'Practice the good habit. As soon as you\'re through the door, hang up your coat. It\'s a small action that shows great responsibility.'
  },
  {
    id: 1136,
    category: QuestCategory.SkillBuilder,
    title: 'The Surface Wiper',
    description: 'Learn to wipe down the kitchen counters after making a snack.',
    details: "Part of being a chef is cleaning your station. After you make a snack, learn to use a cloth and spray to wipe down the counters, leaving them clean for the next person.",
    repeatDescription: 'You just made a snack. Time to wipe down the surfaces.',
    repeatDetails: 'Leave it cleaner than you found it. After snacking, give the kitchen counters a quick wipe. It\'s the professional way to do things.'
  },
  {
    id: 1137,
    category: QuestCategory.SkillBuilder,
    title: 'The Time Teller',
    description: 'Practice telling the time on an analogue clock.',
    details: "Reading a clock with hands is a classic skill. Find an analogue clock and practice telling the time. Learn about the hour hand and the minute hand, and what 'quarter past' and 'half past' mean.",
    repeatDescription: 'Find an analogue clock. What time is it right now?',
    repeatDetails: 'Keep your time-telling skills sharp. Look at a clock with hands and read the time. How many minutes until the next hour?'
  },
  {
    id: 1138,
    category: QuestCategory.SkillBuilder,
    title: 'The Direction Master',
    description: 'Learn the four cardinal directions: North, East, South, and West.',
    details: "Become a master of navigation. Ask an adult to help you figure out which way is North from your house (the sun can help!). Once you know North, you can figure out the others. This is a fundamental explorer's skill.",
    repeatDescription: 'Stand outside. Point to the North, East, South, and West.',
    repeatDetails: 'Time for a navigation check. Without help, can you point in the four cardinal directions? This knowledge will help you read maps and understand the world.'
  },
  {
    id: 1139,
    category: QuestCategory.SkillBuilder,
    title: 'The Car Cleaner',
    description: 'Learn to help keep the car tidy by taking out any rubbish.',
    details: "A clean car is a happier ride. Your mission is to do a sweep of the car, collecting any rubbish like empty wrappers or bottles and putting them in the bin. It's a great way to help out.",
    repeatDescription: 'The car needs a tidy. Go and clear out any rubbish.',
    repeatDetails: 'Help keep the family car clean. Take a bag with you and clear out any rubbish you can find. It makes a big difference.'
  },
  {
    id: 1140,
    category: QuestCategory.SkillBuilder,
    title: 'The Goal Setter',
    description: 'Think of one small, achievable goal for the week and write it down.',
    details: "What is one thing you want to improve or achieve this week? It could be 'read a whole chapter of my book' or 'practice my typing every day'. Write it down in your notebook. Having a goal gives you focus.",
    repeatDescription: 'Set a new goal for this week.',
    repeatDetails: "Time to set a new intention. What's a new skill you want to practice or a task you want to complete this week? Write it down and make a plan to achieve it."
  },
  {
    id: 1141,
    category: QuestCategory.SkillBuilder,
    title: 'The Post-Collector',
    description: 'Learn the responsibility of bringing in the post.',
    details: "Be the official family courier. Your task is to check the letterbox each day and bring any post inside, putting it in the designated spot for the adults to check.",
    repeatDescription: 'Check the letterbox. Is there any post today?',
    repeatDetails: "Time for your courier duties. Check for post and bring it inside. It's a reliable and helpful job."
  },
  {
    id: 1142,
    category: QuestCategory.SkillBuilder,
    title: 'The Hand-Washer Pro',
    description: 'Learn to wash your hands properly for 20 seconds.',
    details: "Washing your hands is one of the best ways to stay healthy. Learn the proper technique: use soap, lather up for 20 seconds (the time it takes to sing 'Happy Birthday' twice), and rinse well. Do this before every meal.",
    repeatDescription: 'Time to eat? Wash your hands like a pro first.',
    repeatDetails: "Practice good hygiene. Before you eat, wash your hands thoroughly for 20 seconds. It's a skill that keeps you and everyone around you healthy."
  },
  {
    id: 1143,
    category: QuestCategory.SkillBuilder,
    title: 'The Self-Reflector',
    description: 'At the end of the day, think of one thing that went well.',
    details: "Practicing positive thinking helps build a happy mind. Before you sleep, take a moment to think about your day. What is one thing that made you smile or that you were proud of? It can be big or small.",
    repeatDescription: 'Reflect on your day. What was one good thing that happened?',
    repeatDetails: 'End the day on a positive note. Think of one highlight from your day. This simple habit helps you appreciate the good things in life.'
  },
  {
    id: 1147,
    category: QuestCategory.SkillBuilder,
    title: 'The Patient Quester',
    description: 'Practice patience by waiting for something without complaining.',
    details: "Patience is a virtue. The next time you have to wait for something—for dinner to be ready, for a game to load—your mission is to wait patiently, without asking 'Is it ready yet?'. Find a way to occupy your mind for those few minutes.",
    repeatDescription: 'A waiting challenge appears! Practice your patience.',
    repeatDetails: "The next time you have to wait, see it as a chance to train your patience. It's a skill that makes life much less frustrating."
  },
  {
    id: 1148,
    category: QuestCategory.SkillBuilder,
    title: 'The Paper Folder',
    description: 'Learn to fold a piece of paper neatly to fit in an envelope.',
    details: "A neatly folded letter looks professional. Learn the standard 'letter fold'—folding the paper into thirds. Practice until you can do it without messy creases. It's a simple but valuable skill.",
    repeatDescription: 'Practice your letter-folding skills.',
    repeatDetails: 'Grab a piece of A4 paper and practice folding it neatly into thirds. A crisp, clean fold is the mark of a pro.'
  },
  {
    id: 1150,
    category: QuestCategory.SkillBuilder,
    title: 'The Independent Player',
    description: 'Practice entertaining yourself for 30 minutes.',
    details: "Learning to enjoy your own company is a great skill. Your mission is to find something to do on your own for 30 minutes, without asking for help or entertainment. You could read, draw, build, or listen to music. The choice is yours.",
    repeatDescription: 'Time for some independent fun. Entertain yourself for 30 minutes.',
    repeatDetails: 'What new adventure can you have on your own? Find a solo activity to enjoy for half an hour. This skill builds creativity and independence.'
  },
  {
    id: 1151,
    category: QuestCategory.SkillBuilder,
    title: 'Lace-Tying Master',
    description: 'Learn the essential life skill of tying your own shoelaces.',
    details: 'Find a shoe with laces and an adult to show you the "bunny ears" or "loop-swoop-and-pull" method. Practice it 10 times. It\'s tricky at first, but soon it will be automatic!',
    repeatDescription: 'Practice makes perfect. Tie your shoes today.',
    repeatDetails: 'Time to practice tying your laces. The more you do it, the faster you\'ll get. A well-tied shoe is a safe shoe!'
  }
];